
export const colors = {
  blue: "#2357BD",
  black: "#000000",
  white: "#ffffff",
  darkBlue: "#2d328a",
  pagebackground: "white",
  transparent: "rgba(0,0,0,0)",
  danger: "#EC070B",
  danger_bg_transparent: "#EC070B30",
  success: "#0E7C00",
  success_bg_transparent: "#0E7C0030",
  primary: "#47A7FD",
  orange: "#FE911C",
};
